import * as React from "react"
import en_US from "./en_US"

type Context = typeof en_US

const LocaleContext = React.createContext<Context>(en_US)

export default LocaleContext
